import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import api from '../utils/api';

const About = () => {
  const [orgDetails, setOrgDetails] = useState({});
  const [copySuccess, setCopySuccess] = useState('');
  const donationLink = orgDetails.creditcardPage || 'N/A';

  const buildDate = process.env.REACT_APP_BUILD_DATE || 'N/A';
  const buildVersion = process.env.REACT_APP_BUILD_VERSION || 'N/A';

  // Convert buildDate to local time if it's not 'N/A'
  const localBuildDate = buildDate !== 'N/A' ? new Date(buildDate).toLocaleString() : 'N/A';

  useEffect(() => {
    const fetchOrgDetails = async () => {
      try {
        const response = await api.get('/api/appconfig'); // Axios call
        console.log('Response:', response); // Log the response
        setOrgDetails(response.data.data || {}); // Access data directly from response.data
      } catch (error) {
        console.error('Error fetching organization details:', error);
      }
    };

    fetchOrgDetails();
  }, []);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Donate Now',
          text: 'Join me in supporting this cause! Click the link to donate:',
          url: donationLink,
        });
      } catch (err) {
        console.error('Error sharing:', err);
      }
    } else {
      navigator.clipboard.writeText(donationLink)
        .then(() => {
          setCopySuccess('Link copied to clipboard!');
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
        });
    }
  };

  return (
    <Container className="mt-5">
      <Row className="mb-4">
        <Col className="text-center">
          <h1>{orgDetails.name || 'N/A'}</h1>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <p>
            <strong>Organization Address:</strong><br />
            {orgDetails.address || 'N/A'}, {orgDetails.city || 'N/A'}, {orgDetails.state || 'N/A'}, {orgDetails.zip || 'N/A'}
          </p>
          <p>
            <strong>Mailing Address:</strong><br />
            {orgDetails.mailingAddress || 'N/A'}
          </p>
          <p>
            <strong>Phone:</strong><br />
            {orgDetails.phone || 'N/A'}
          </p>
          <p>
            <strong>Email:</strong><br />
            <a href={`mailto:${orgDetails.email || ''}`}>
              {orgDetails.email || 'N/A'}
            </a>
          </p>
          <p>
            <strong>Website:</strong><br />
            <a href={orgDetails.website || '#'} target="_blank" rel="noopener noreferrer">
              {orgDetails.website ? 'Visit our Website' : 'N/A'}
            </a>
          </p>
          <p>
            <strong>Facebook Page:</strong><br />
            <a href={orgDetails.facebookPage || '#'} target="_blank" rel="noopener noreferrer">
              {orgDetails.facebookPage ? 'Visit our Facebook Page' : 'N/A'}
            </a>
          </p>
          <p>
            <strong>Technical Support Email:</strong><br />
            <a href="mailto:orgmscloud@yahoo.com">orgmscloud@yahoo.com</a>
          </p>
          <p className="small-font">Build Date: {localBuildDate}</p>
          {buildVersion !== 'N/A' && (
            <p className="small-font">Build Version: {buildVersion}</p>
          )}
        </Col>
        <Col md={6} className="d-flex flex-column align-items-center justify-content-center">
          <a href={donationLink} className="btn btn-primary mb-3" target="_blank" rel="noopener noreferrer">
            Donate Now using Credit Card
          </a>
          {orgDetails.qrCodeImage ? (
            <img
              src={`/${orgDetails.qrCodeImage}`}
              alt="QR Code"
              style={{ width: '150px', height: '150px' }}
            />
          ) : (
            <p>QR Code not available</p>
          )}
          <p className="mt-2">Scan the QR code to donate</p>

          {/* Share button */}
          <button onClick={handleShare} className="btn btn-secondary mt-3">
            Share Donation Link
          </button>
          {copySuccess && <p className="text-success mt-2">{copySuccess}</p>}
        </Col>
      </Row>
    </Container>
  );
};

export default About;